"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./GridGame.scss");
var _DraggableItem = _interopRequireDefault(require("./DraggableItem"));
var _DropSquare = _interopRequireDefault(require("./DropSquare"));
var _ResultItem = _interopRequireDefault(require("./ResultItem"));
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = _interopRequireDefault(require("react-dnd-html5-backend"));
var _reactDndTouchBackend = _interopRequireDefault(require("react-dnd-touch-backend"));
var _reactDndMultiBackend = _interopRequireWildcard(require("react-dnd-multi-backend"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } //import backRef from './img/build-the-grid-position-reference.jpg';
//import background from './img/build-the-grid-background.jpg';
// import HTML5toTouch from 'react-dnd-multi-backend/lib/HTML5toTouch';
// @NOTE for touch support, we may need to replace with 
// import { default as TouchBackend } from 'react-dnd-touch-backend';
var HTML5toTouch = {
  backends: [{
    backend: _reactDndHtml5Backend["default"]
  }, {
    backend: (0, _reactDndTouchBackend["default"])({
      enableMouseEvents: true
    }),
    preview: true,
    transition: _reactDndMultiBackend.TouchTransition
  }]
};
var GridGame = /*#__PURE__*/function (_Component) {
  _inherits(GridGame, _Component);
  var _super = _createSuper(GridGame);
  function GridGame(props) {
    var _this;
    _classCallCheck(this, GridGame);
    _this = _super.call(this, props);
    _this.state = {
      handler1: null,
      handler2: null,
      handler3: null,
      allOn: false
    };
    _this.dropFunction = _this.dropFunction.bind(_assertThisInitialized(_this));
    _this.checkIfAllOn = _this.checkIfAllOn.bind(_assertThisInitialized(_this));
    _this.generatePreview = _this.generatePreview.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(GridGame, [{
    key: "generatePreview",
    value: function generatePreview(type, item, style) {
      console.log('[generatePreview]', type, item, style);
      var _this$props$elements = this.props.elements,
        boldTowersB = _this$props$elements.boldTowersB,
        substationB = _this$props$elements.substationB,
        utilityPolesB = _this$props$elements.utilityPolesB;
      var element, className;
      switch (item.name) {
        case 'towers':
          element = boldTowersB;
          className = 'bold-towers-container';
          break;
        case 'substation':
          element = substationB;
          className = 'substation-container';
          break;
        case 'poles':
          element = utilityPolesB;
          className = 'utility-poles-container';
      }
      return /*#__PURE__*/_react["default"].createElement("img", {
        className: "interactive-item ".concat(className),
        src: element.src,
        style: _objectSpread({
          cursor: 'move',
          zIndex: 999
        }, style)
      });
    }
  }, {
    key: "dropFunction",
    value: function dropFunction(item, target) {
      if (target === 'handler1' && item === 'towers' || target === 'handler2' && item === 'substation' || target === 'handler3' && item === 'poles') {
        this.setState(_defineProperty({}, target, 'off'), this.checkIfAllOn);
      }
    }
  }, {
    key: "checkIfAllOn",
    value: function checkIfAllOn() {
      if (this.state.handler1 && this.state.handler2 && this.state.handler3) {
        this.setState({
          allOn: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var elements = this.props.elements;
      var background = elements.background;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-game-container",
        style: {
          overflow: 'hidden',
          clear: 'both'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-container body"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "BUILDING AN ENERGY DELIVERY SYSTEM"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "intro-text"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Put your knowledge about energy delivery to use!"), /*#__PURE__*/_react["default"].createElement("p", null, "Use your finger to drag and drop transmission lines, towers, distribution lines and transformers to create an energy delivery system from a power station to a local business."))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "interactive-container"
      }, /*#__PURE__*/_react["default"].createElement(_ResultItem["default"], {
        name: "powerPlant",
        elements: elements
      }), /*#__PURE__*/_react["default"].createElement(_reactDndMultiBackend.Preview, {
        generator: this.generatePreview
      }), /*#__PURE__*/_react["default"].createElement(_ResultItem["default"], {
        name: "house",
        elements: elements,
        status: this.state.allOn ? 'on' : undefined
      }), this.state.handler1 ? /*#__PURE__*/_react["default"].createElement(_ResultItem["default"], {
        name: "towers",
        elements: elements,
        status: this.state.allOn ? 'on' : this.state.handler1
      }) : /*#__PURE__*/_react["default"].createElement(_DropSquare["default"], {
        name: "handler1",
        elements: elements
      }), this.state.handler2 ? /*#__PURE__*/_react["default"].createElement(_ResultItem["default"], {
        name: "substation",
        elements: elements,
        status: this.state.allOn ? 'on' : this.state.handler2
      }) : /*#__PURE__*/_react["default"].createElement(_DropSquare["default"], {
        name: "handler2",
        elements: elements
      }), this.state.handler3 ? /*#__PURE__*/_react["default"].createElement(_ResultItem["default"], {
        name: "poles",
        elements: elements,
        status: this.state.allOn ? 'on' : this.state.handler3
      }) : /*#__PURE__*/_react["default"].createElement(_DropSquare["default"], {
        name: "handler3",
        elements: elements
      }), this.state.handler1 ? null : /*#__PURE__*/_react["default"].createElement(_DraggableItem["default"], {
        name: "towers",
        elements: elements,
        dropFunction: this.dropFunction
      }), this.state.handler2 ? null : /*#__PURE__*/_react["default"].createElement(_DraggableItem["default"], {
        name: "substation",
        elements: elements,
        dropFunction: this.dropFunction
      }), this.state.handler3 ? null : /*#__PURE__*/_react["default"].createElement(_DraggableItem["default"], {
        name: "poles",
        elements: elements,
        dropFunction: this.dropFunction
      })), this.state.allOn ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "result-container"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Great Job!"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "intro-text"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "You successfully built the grid."))) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "background-container"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: "background-reference",
        src: background.src,
        style: {
          opacity: 0.7
        }
      })));
    }
  }]);
  return GridGame;
}(_react.Component);
GridGame.defaultProps = {};
GridGame.propTypes = {};
var _default = (0, _reactDnd.DragDropContext)((0, _reactDndMultiBackend["default"])(HTML5toTouch))(GridGame);
exports["default"] = _default;